import React, { Suspense } from "react";
import { Outlet, Route, Routes } from "react-router-dom";
import { EpPageProvider } from "../Components/EpPage";
import { PageLoadingFallback } from "../Components/LoadingFallback";
import { ROUTER_BASE } from "../Components/Link";
import { CompatibleEigentxRedirect } from "../EigenTx/CompatibleRedirect";

const ContainerRouter = () => {
  const HomePage = React.lazy(
    () => import(/* webpackChunkName: "HomePage" */ "../Home/HomePage")
  );
  const ContractPage = React.lazy(
    () =>
      import(/* webpackChunkName: "ContractPage" */ "../Contract/ContractPage")
  );
  const TransactionFlowPage = React.lazy(
    () =>
      import(
        /* webpackChunkName: "TransactionFlowPage" */ "../Transaction/TransactionFlowPage"
      )
  );
  const TokenDetailPage = React.lazy(
    () =>
      import(
        /* webpackChunkName: "TokenDetailPage" */ "../Token/TokenDetailPage"
      )
  );
  const PoolDetailPage = React.lazy(
    () =>
      import(/* webpackChunkName: "PoolDetailPage" */ "../Pool/PoolDetailPage")
  );
  const PoolPage = React.lazy(
    () => import(/* webpackChunkName: "PoolPage" */ "../Pool/PoolPage")
  );
  const TokenPage = React.lazy(
    () => import(/* webpackChunkName: "TokenPage" */ "../Token/TokenPage")
  );
  const NotFoundPage = React.lazy(
    () =>
      import(/* webpackChunkName: "NotFoundPage" */ "../OtherPage/NotFoundPage")
  );
  const ErrorPage = React.lazy(
    () => import(/* webpackChunkName: "ErrorPage" */ "../OtherPage/ErrorPage")
  );
  const TransactionRealtimePage = React.lazy(
    () =>
      import(
        /* webpackChunkName: "TransactionRealtimePage" */ "../Transaction/TransactionRealtimePage"
      )
  );
  const SandwichSubjectPage = React.lazy(
    () =>
      import(
        /* webpackChunkName: "SandwichSubjectPage" */ "../Sandwich/SubjectPage"
      )
  );
  const SandwichAttackerDetailPage = React.lazy(
    () =>
      import(
        /* webpackChunkName: "SandwichAttackerDetailPage" */ "../Sandwich/AttackerDetailPage"
      )
  );
  const SandwichVictimDetailPage = React.lazy(
    () =>
      import(
        /* webpackChunkName: "SandwichVictimDetailPage" */ "../Sandwich/VictimDetailPage"
      )
  );
  const SandwichVictimDetailPageTG = React.lazy(
    () =>
      import(
        /* webpackChunkName: "SandwichVictimDetailPageTG" */ "../Sandwich/VictimDetailPageTG"
      )
  );
  const LiquidationMarketPage = React.lazy(
    () =>
      import(
        /* webpackChunkName: "LiquidationMarketPage" */ "../Liquidation/MarketPage"
      )
  );
  const LiquidationProtocolPage = React.lazy(
    () =>
      import(
        /* webpackChunkName: "LiquidationProtocolPage" */ "../Liquidation/ProtocolPage"
      )
  );
  const LiquidationBorrowerPage = React.lazy(
    () =>
      import(
        /* webpackChunkName: "LiquidationBorrowerPage" */ "../Liquidation/BorrowerPage"
      )
  );
  const LiquidationLiquidatorPage = React.lazy(
    () =>
      import(
        /* webpackChunkName: "LiquidationLiquidatorPage" */ "../Liquidation/LiquidatorPage"
      )
  );
  const LiquidationDetailPage = React.lazy(
    () =>
      import(
        /* webpackChunkName: "LiquidationDetailPage" */ "../Liquidation/DetailPage"
      )
  );
  const FlashloanMarketPage = React.lazy(
    () =>
      import(
        /* webpackChunkName: "FlashloanMarketPage" */ "../Flashloan/MarketPage"
      )
  );
  const SearchResultPage = React.lazy(
    () =>
      import(/* webpackChunkName: "SearchResultPage" */ "../Search/ResultPage")
  );
  const DailyReportPage = React.lazy(
    () =>
      import(
        /* webpackChunkName: "DailyReportPage" */ "../DailyReport/DailyReportPage"
      )
  );
  const EigenTxSearchPage = React.lazy(
    () =>
      import(
        /* webpackChunkName: "EigenTxSearchPage" */ "../EigenTx/SearchPage"
      )
  );
  const EigenTxPage = React.lazy(
    () => import(/* webpackChunkName: "EigenTxPage" */ "../EigenTx/TxPage")
  );
  const EigenTxMultiPage = React.lazy(
    () =>
      import(
        /* webpackChunkName: "EigenTxPage" */ "../EigenTx/MultiTxPage/MultiTxPage"
      )
  );

  return (
    <Routes>
      <Route path={`${ROUTER_BASE}`} element={<Outlet />}>
        <Route
          path="eigentx"
          element={
            <Suspense fallback={<PageLoadingFallback />}>
              <EpPageProvider pageId="EigenTxSearch">
                <EigenTxSearchPage />
              </EpPageProvider>
            </Suspense>
          }
        />
        <Route
          path="eigentx/:txhash"
          element={
            <Suspense fallback={<PageLoadingFallback />}>
              <EpPageProvider pageId="EigenTx">
                <EigenTxPage />
              </EpPageProvider>
            </Suspense>
          }
        />
        <Route
          path="eigentx/multi/:txhash"
          element={
            <Suspense fallback={<PageLoadingFallback />}>
              <EpPageProvider pageId="EigenTxMulti">
                <EigenTxMultiPage />
              </EpPageProvider>
            </Suspense>
          }
        />
      </Route>
      <Route
        path="/"
        element={
          <Suspense fallback={<PageLoadingFallback />}>
            <EpPageProvider pageId="Market Overview">
              <HomePage />
            </EpPageProvider>
          </Suspense>
        }
      />
      <Route
        path="/index.html"
        element={
          <Suspense fallback={<PageLoadingFallback />}>
            <EpPageProvider>
              <HomePage />
            </EpPageProvider>
          </Suspense>
        }
      />
      <Route
        path="/error"
        element={
          <Suspense fallback={<PageLoadingFallback />}>
            <EpPageProvider>
              <ErrorPage />
            </EpPageProvider>
          </Suspense>
        }
      />
      <Route
        path="/404"
        element={
          <Suspense fallback={<PageLoadingFallback />}>
            <EpPageProvider>
              <NotFoundPage />
            </EpPageProvider>
          </Suspense>
        }
      />
      <Route path={`${ROUTER_BASE}/:chainId`} element={<Outlet />}>
        <Route path="eigentx/:txhash" element={<CompatibleEigentxRedirect />} />
        <Route
          path=""
          element={
            <Suspense fallback={<PageLoadingFallback />}>
              <EpPageProvider>
                <HomePage />
              </EpPageProvider>
            </Suspense>
          }
        ></Route>
        <Route
          path=":period"
          element={
            <Suspense fallback={<PageLoadingFallback />}>
              <EpPageProvider>
                <HomePage />
              </EpPageProvider>
            </Suspense>
          }
        ></Route>
        <Route
          path="contract/:address"
          element={
            <Suspense fallback={<PageLoadingFallback />}>
              <EpPageProvider pageId="Contract Portfolio">
                <ContractPage />
              </EpPageProvider>
            </Suspense>
          }
        />
        <Route
          path="tx/:txHash"
          element={
            <Suspense fallback={<PageLoadingFallback />}>
              <EpPageProvider pageId="Arbitrage Transaction">
                <TransactionFlowPage />
              </EpPageProvider>
            </Suspense>
          }
        />
        <Route
          path="lp/:address"
          element={
            <Suspense fallback={<PageLoadingFallback />}>
              <EpPageProvider pageId="Liquidity Pool Profile">
                <PoolDetailPage />
              </EpPageProvider>
            </Suspense>
          }
        />
        <Route
          path="pools/:poolType"
          element={
            <Suspense fallback={<PageLoadingFallback />}>
              <EpPageProvider>
                <PoolPage />
              </EpPageProvider>
            </Suspense>
          }
        />
        <Route
          path="tokens/:tokenType"
          element={
            <Suspense fallback={<PageLoadingFallback />}>
              <EpPageProvider>
                <TokenPage />
              </EpPageProvider>
            </Suspense>
          }
        />
        <Route
          path="token/:address"
          element={
            <Suspense fallback={<PageLoadingFallback />}>
              <EpPageProvider pageId="Token Profile">
                <TokenDetailPage />
              </EpPageProvider>
            </Suspense>
          }
        />
        <Route
          path="txr"
          element={
            <Suspense fallback={<PageLoadingFallback />}>
              <EpPageProvider pageId="MEV Live-Stream">
                <TransactionRealtimePage />
              </EpPageProvider>
            </Suspense>
          }
        />
        <Route
          path="sandwich"
          element={
            <Suspense fallback={<PageLoadingFallback />}>
              <EpPageProvider pageId="Sandwich Overview">
                <SandwichSubjectPage />
              </EpPageProvider>
            </Suspense>
          }
        />
        <Route
          path="sandwich/attacker/:address"
          element={
            <Suspense fallback={<PageLoadingFallback />}>
              <EpPageProvider pageId="Sandwich Attacker Profile">
                <SandwichAttackerDetailPage />
              </EpPageProvider>
            </Suspense>
          }
        />
        <Route
          path="sandwich/victim/:address"
          element={
            <Suspense fallback={<PageLoadingFallback />}>
              <EpPageProvider pageId="Sandwich Victim Profile">
                <SandwichVictimDetailPage />
              </EpPageProvider>
            </Suspense>
          }
        />
        <Route
          path="tg/sandwich-detector/:address?"
          element={
            <Suspense fallback={<PageLoadingFallback />}>
              <EpPageProvider pageId="Sandwich Detector">
                <SandwichVictimDetailPageTG />
              </EpPageProvider>
            </Suspense>
          }
        />
        <Route
          path="liquidation"
          element={
            <Suspense fallback={<PageLoadingFallback />}>
              <EpPageProvider pageId="Liquidation Overview">
                <LiquidationMarketPage />
              </EpPageProvider>
            </Suspense>
          }
        />
        <Route
          path="liquidation/protocol/:protocol"
          element={
            <Suspense fallback={<PageLoadingFallback />}>
              <EpPageProvider pageId="Protocol Overview">
                <LiquidationProtocolPage />
              </EpPageProvider>
            </Suspense>
          }
        />
        <Route
          path="liquidation/borrower/:address"
          element={
            <Suspense fallback={<PageLoadingFallback />}>
              <EpPageProvider pageId="Borrower">
                <LiquidationBorrowerPage />
              </EpPageProvider>
            </Suspense>
          }
        />
        <Route
          path="liquidation/liquidator/:address"
          element={
            <Suspense fallback={<PageLoadingFallback />}>
              <EpPageProvider pageId="Liquidator">
                <LiquidationLiquidatorPage />
              </EpPageProvider>
            </Suspense>
          }
        />
        <Route
          path="liquidation/tx/:txHash"
          element={
            <Suspense fallback={<PageLoadingFallback />}>
              <EpPageProvider pageId="Liquidation Transaction">
                <LiquidationDetailPage />
              </EpPageProvider>
            </Suspense>
          }
        />
        <Route
          path="flashloan"
          element={
            <Suspense fallback={<PageLoadingFallback />}>
              <EpPageProvider pageId="Flashloan">
                <FlashloanMarketPage />
              </EpPageProvider>
            </Suspense>
          }
        />
        <Route
          path="search"
          element={
            <Suspense fallback={<PageLoadingFallback />}>
              <EpPageProvider pageId="GlobalSearch">
                <SearchResultPage />
              </EpPageProvider>
            </Suspense>
          }
        />
        <Route
          path="dailyReport"
          element={
            <Suspense fallback={<PageLoadingFallback />}>
              <EpPageProvider>
                <DailyReportPage />
              </EpPageProvider>
            </Suspense>
          }
        />
        <Route
          path="dailyReport/:type"
          element={
            <Suspense fallback={<PageLoadingFallback />}>
              <EpPageProvider>
                <DailyReportPage />
              </EpPageProvider>
            </Suspense>
          }
        />
        <Route
          path="dailyReport/:type/:date"
          element={
            <Suspense fallback={<PageLoadingFallback />}>
              <EpPageProvider>
                <DailyReportPage />
              </EpPageProvider>
            </Suspense>
          }
        />
      </Route>
      <Route path="*" element={<p>404 not found</p>} />
    </Routes>
  );
};

export default ContainerRouter;
